export const menuRoutes = {
  clients: '/client/list',
  holdings: '/holdings',
  model: '/model/list',
  bulkFunctions: '/bulk/email',
  security: '/security/list',
  workflow: '/workflow/list',
  templates: '/templates',
};
